export default __webpack_public_path__ + "static/fav-img02-6ad466c117dd3a26bb48f2a033c26d30.jpg";